<template>
    <div class="personalMain">
        <p class="current">当前位置：<span>我的积分</span></p>
        <div class="integral-box">
            <Menu></Menu>
            <div class="MainInfo-inte">
                <div class="inte-box">
                    <div>
                        <p style="font-size: 25px;font-weight: 700;">{{ integralList[0].cur_total }}</p>
                        <span>账户可用积分</span>
                    </div>
                   
                </div>
                <div class="inte-context">
                    <div v-for="item in integralList" :key='item.id' class="list-Item">
                        <div>
                            <p>{{ item.remark }}</p>
                            <span>{{ item.create_time }}</span>

                        </div>
                        
                        <p><span v-if="item.total>0">+</span>{{ item.total }}</p>
                    </div>
                
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            
          
        </div>
    </div>
</template>

<script>
import Menu from './index.vue'
export default{
    data(){
        return{
            total: 0,
            hideOnSinglePage: true,
            integralList: [],
            widthNew: false
        }
    },
    components:{
        Menu
    },
    methods: {
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            
        },
        getDateTime(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
        listSelf(data){
            this.$store.dispatch('personal/listSelf',data)
                .then(res => {
                    if(res.ok){
                        this.total = res.data.total
                        this.integralList = res.data.items
                        this.integralList.forEach(item => {
                            const timeDate = new Date(item.create_time)
                            item.create_time = this.getDateTime(timeDate)
                        });
                        
                        if(this.total <= 10){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        }
    },  
    mounted(){
        let data = {
            pageNum: '1',
            pageSize: '20'
        }

        this.listSelf(data)
        
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }
}
</script>


<style scoped lang="scss">

.MainInfo-inte{
    width: 910px;
    background: #fff;
    padding: 20px 20px;
    min-height: 700px;
}
.inte-box{
  padding-left: 10px;
  padding-bottom: 15px;
  border-bottom: 0.5px solid #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
}
.inte-box p{
  margin-bottom: 6px;
}
.inte-box span{
  font-size: 16px;
  color: #666666;
}

.list-Item{
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 10px;
  border-bottom: 0.5px solid #f2f2f2;
  font-size: 22px;
  div p{
    font-size: 18px;
  }
  p{
    font-size: 24px;
  }
  span{
    font-size: 16px;
    color: #666666;
  }
  
}

@media screen and (min-width: 541px) {
    .integral-box{
        width: 1200px;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
}
@media screen and (max-width: 540px) {
    .integral-box{
        width: 96%;
        margin: 10px auto;
    }
    .MainInfo-inte{
        width: 100%;
        margin: 0 auto;
        padding: 20px 0px;
    }
    .inte-box{
        padding: 0 10px 15px 10px;
        font-size: 18px;
    }
    .inte-box span{
        font-size: 14px;
    }

    .list-Item{
        padding: 0 10px 20px 10px;
        font-size: 20px;
    }
    .list-Item span{
        font-size: 14px;
    }
}
</style>